
function sendAnalytics(metricType, metricObj) {
  console.log('metricType', metricType);
  console.log('metricObj', metricObj);

  if (typeof metricType === 'undefined') {
    return;
  }

  window.mready = window.mready || [];
  window.mready.push(function(metrics) {
    metrics[metricType](metricObj);
    //console.log('election metrics pushed');
  });

}


const eventTracking = (trackingData) => {
  console.log(trackingData);
  if (window.utag) {
    const { metric = 'ev', events = [ 'event10' ] } = trackingData;

    if (trackingData) {
      sendAnalytics(metric, {
        events,
        itm: {
          site: window.utag ? window.utag.data.net_site : null,
          section: window.utag ? window.utag.data.net_sec2 : null,
          container: trackingData.container,
          label: trackingData.label,
          order: trackingData.order,
          pagename: window.utag ? window.utag.data.net_pn : null,
          contenttype: window.utag ? window.utag.data.net_content_type : null,
        }
      });
    }
  }
};

export default eventTracking;
